import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{attrs:{"grid-list-xl":"","fluid":""}},[_c('div',{staticClass:"d-flex flex-row justify-center"},[_c(VAvatar,{attrs:{"size":"150px","color":"white"}},[_c('img',{attrs:{"src":'/img/avatars/default-logo-'+_vm.$store.getters.appType+'.png',"alt":"user"}})])],1),_c('div',{staticClass:"d-flex flex-row justify-center mt-10"},[_vm._v("\n        "+_vm._s(_vm.$t('general.welcome_text'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }